import { Routes, UrlSegment } from '@angular/router';
import { ClassicLayout } from './layout/classic-layout/classic-layout';
import { Dashboard } from './features/dashboard/dashboard';
import { AuthenticationComponent } from './features/auth/authentication-component/authentication-component';
import { authGuard } from './core/guards/auth.guard';

import { roleGuard } from './core/guards/role.guard';

import { environment } from '../environments/environment';

export function tokenMatcher(url: UrlSegment[]) {
    if (url.length === 1 && url[0].path.startsWith('token=')) {
        return {
            consumed: url,
            posParams: { paramToken: new UrlSegment(url[0].path, {}) }
        };
    }
    return null;
}

export const routes: Routes = [
    {
        path: '',
        component: ClassicLayout,
        children: [
            { path: '', component: Dashboard, },
            { path: 'inicio', component: Dashboard, },
            { 
                path: 'asistencia-reportes', 
                loadChildren: () => import('./features/asistencia-reportes/asistencia-reportes.router').then(m => m.asistenciaReportesRouter),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO', 'DIRECTOR', 'AUXILIAR', 'DOCENTE']
                } 
            },
            {
                path: 'estudiantes',
                loadChildren: () => import('./features/estudiantes/estudiantes.router').then(m => m.estudiantesRouter),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO', 'DIRECTOR', 'AUXILIAR', 'DOCENTE']
                }
            },
            {
                path: 'edicion-datos',
                loadChildren: () => import('./features/edicion-datos/edicion-datos.routes').then(m => m.edicionDatosRouter),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'SUPER USER']
                }
            },
            { 
                path: 'registro-asistencia', 
                loadChildren: () => import('./features/registro-asistencia/registro-asistencia.routes').then(m => m.REGISTRO_ASISTENCIA_ROUTES),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'AUXILIAR', 'AUXI-BOT']
                } 
            },
            {
                path: 'calendario',
                loadChildren: () => import('./features/calendario/calendario.routes').then(m => m.CALENDARIO_ROUTES),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO', 'DIRECTOR', 'AUXILIAR', 'DOCENTE', 'PADRE', 'ESTUDIANTE']
                }
            },
            {
                path: 'perfil',
                loadComponent: () => import('./features/perfil/perfil.component').then(m => m.PerfilComponent),
                canActivate: [roleGuard],
                data: {
                    roles: ['Super User', 'ADMINISTRADOR', 'DIRECTIVO', 'DOCENTE', 'AUXILIAR', 'PADRE', 'ESTUDIANTE']
                }
            },
            { 
                path: 'administracion-ie', 
                loadChildren: () => import('./features/administracion-ie/administracion-ie.routes').then(m => m.ADMINISTRACION_IE_ROUTES),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO'] // Also 'Super User' if needed, but per matrix Admin/Dir
                }
            },
            { 
                path: 'notificaciones', 
                loadChildren: () => import('./features/notificaciones/notificaciones.router').then(m => m.notificacionesRouter),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO', 'DIRECTOR', 'AUXILIAR', 'DOCENTE', 'PADRE', 'ESTUDIANTE']
                } 
            },
            {
                path: 'staff',
                loadChildren: () => import('./features/staff/staff.routes').then(m => m.STAFF_ROUTES),
                canActivate: [roleGuard],
                data: {
                    roles: ['ADMINISTRADOR', 'DIRECTIVO', 'DIRECTOR', 'AUXILIAR', 'DOCENTE', 'PADRE', 'ESTUDIANTE']
                }
            },
            { 
                path: 'mi-institucion', 
                loadComponent: () => import('./features/mi-institucion/mi-institucion.component').then(m => m.MiInstitucionComponent),
                canActivate: [roleGuard],
                data: {
                    roles: ['SUPER USER', 'ADMINISTRADOR', 'DIRECTIVO', 'PADRE', 'ESTUDIANTE', 'DOCENTE', 'AUXILIAR']
                } 
            },
            {
                path: 'asistencia-hijos',
                loadComponent: () => import('./features/asistencia-hijos/asistencia-hijos.component').then(m => m.AsistenciaHijosComponent),
                canActivate: [roleGuard],
                data: {
                    roles: ['PADRE', 'ESTUDIANTE']
                }
            },
            {
                path: 'mantenimiento-instituciones',
                loadComponent: () => import('./features/mantenimiento-instituciones/instituciones-list.component').then(m => m.InstitucionesListComponent),
                canActivate: [roleGuard],
                data: { roles: ['SUPER USER'] }
            },
            {
                path: 'mantenimiento-usuarios',
                loadComponent: () => import('./features/user-maintenance/user-list.component').then(m => m.UserListComponent),
                canActivate: [roleGuard],
                data: { roles: ['ADMINISTRADOR'], mode: 'regular' }
            },
            {
                path: 'mantenimiento-usuarios-super',
                loadComponent: () => import('./features/user-maintenance/user-list.component').then(m => m.UserListComponent),
                canActivate: [roleGuard],
                data: { roles: ['SUPER USER'], mode: 'super' }
            },
            ...(!environment.production ? [{
                path: 'practica-pedagogica',
                loadChildren: () => import('./features/practica-pedagogica/practica-pedagogica.routes').then(m => m.PRACTICA_PEDAGOGICA_ROUTES),
                canActivate: [roleGuard],
                data: { roles: ['DIRECTIVO', 'DOCENTE'] }
            }] : [])
        ],
        canActivate: [authGuard]
    },
    { path: 'login', loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent) },
    { path: 'token/:paramToken', loadComponent: () => import('./features/auth/token-login/token-login.component').then(m => m.TokenLoginComponent) },
    { matcher: tokenMatcher, loadComponent: () => import('./features/auth/token-login/token-login.component').then(m => m.TokenLoginComponent) },
    { path: 'auth-identity/:token', component: AuthenticationComponent },
    { path: '**', redirectTo: '/login', pathMatch: 'full' }

];
